// extracted by mini-css-extract-plugin
export var base = "_2p-0";
export var updateBanner = "_2p-1";